import React, { Component } from 'react';
import axios from 'axios';
import { ContentArea } from '../../base/container/container';
import { Button } from '../../base/buttons/buttons';
import './contact.css';

class ContactForm extends Component {
  constructor() {
    super();
    this.defaultValues = {
      name: '',
      email: '',
      subject: '',
      message: '',
    }
    this.state = {
      ...this.defaultValues,
    };
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  handleSubmit = () => {
    const postData = new FormData();
    Object.keys(this.state).forEach(
      (key) => postData.append(key, this.state[key])
    );
    axios.post('/backend/php/contactMailer.php', postData).then(() => {
      this.setState({ ...this.defaultValues });
    }).catch((error) => {
      console.log('Could not send the message...', error);
    });
  }

  render() {
    const { name, email, subject, message } = this.state;
    return(
      <div className="contact-form">
        <input
          id="name" 
          name="name"
          placeholder="Name"
          value={name}
          onChange={this.handleChange}
        />
        <input
          id="email" 
          name="email"
          placeholder="E-Mail"
          value={email}
          onChange={this.handleChange}
        />
        <input
          id="subject" 
          name="subject"
          placeholder="Subject"
          value={subject}
          onChange={this.handleChange}
        />
        <textarea
          id="message" 
          name="message"
          placeholder="Message"
          value={message}
          onChange={this.handleChange}
        />
        <div className="contact-form--submit">
          <Button onClick={this.handleSubmit} content="Submit" />
        </div>
      </div>
    );
  }
}

const Contact = () => {
  return(
    <ContentArea>
      <section className="contact-section" id="contact">
        <h2>Contact us</h2>
        <ContactForm />
      </section>
    </ContentArea>
  );
}

export default Contact;
